/**
 * @param ids - The ids to join
 * @returns The joined ids
 * @example
 * joinTestIds('automation-card', '123') // 'automation-card--123'
 */
export const joinTestIds = (...ids: string[]) => {
  return ids.join('--');
};
